import { useTranslation } from 'react-i18next';
import { TabsList } from '@/shared/ui/tab/components/TabsList';
import { TabsRoot } from '@/shared/ui/tab/components/TabsRoot';
import { TabsTrigger } from '@/shared/ui/tab/components/TabsTrigger';
import type { ProjectDetailTab } from '@/widgets/right-side-menu/ui/ai-chat/project-detail/projectDetailTab';

type Props = {
  value: ProjectDetailTab;
  onValueChange: (next: ProjectDetailTab) => void;
};

export const ProjectDetailAIChatTabs = ({ value, onValueChange }: Props) => {
  const { t } = useTranslation();

  return (
    <TabsRoot value={value} onValueChange={(next) => onValueChange(next as ProjectDetailTab)}>
      <TabsList className="rounded-[10px] bg-surface-strength1 p-[3px]">
        <TabsTrigger value="matching">{t('ai.tabs.matching')}</TabsTrigger>
        <TabsTrigger value="chat">{t('ai.tabs.chat')}</TabsTrigger>
      </TabsList>
    </TabsRoot>
  );
};
